import { render, staticRenderFns } from "./AdminBusinesses.vue?vue&type=template&id=caa5012a&scoped=true"
import script from "./AdminBusinesses.vue?vue&type=script&lang=ts"
export * from "./AdminBusinesses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa5012a",
  null
  
)

export default component.exports